/*
 * Copyright © 2018-2025, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import { axiosCommon } from "../util/axiosSetup";
import { ApiPromise } from "../models/ApiPromise";
import Params from "../common/Params";
import { SpeciesResponse } from "../models/species/SpeciesResponse";
import { SpeciesRequest } from "../models/species/SpeciesRequest";
import { AdminSpeciesResponse } from "../models/species/AdminSpeciesResponse";
import { PublicSpeciesResponse } from "../models/species/PublicSpeciesResponse";

export default class SpeciesApi {
  private static baseUrl = Params.clinicServiceBaseURL;

  /**
   * Get all approved and requested species
   * For admins
   */
  static getAllSpecies(): ApiPromise<Array<AdminSpeciesResponse>> {
    const url = `${this.baseUrl}/species`;
    return axiosCommon.get(url);
  }

  /**
   * Get all approved and requested species by the clinic
   * For clinics
   */
  static getClinicSpecies(clinicId: string): ApiPromise<Array<SpeciesResponse>> {
    const url = `${this.baseUrl}/clinics/${clinicId}/species`;
    return axiosCommon.get(url);
  }

  /**
   * Get all approved species
   * For pet owners
   */
  static getPetOwnerSpecies(): ApiPromise<Array<PublicSpeciesResponse>> {
    const url = `${this.baseUrl}/species/public`;
    return axiosCommon.get(url);
  }

  static addSpecies(request: SpeciesRequest): ApiPromise<SpeciesResponse> {
    const url = `${this.baseUrl}/species`;
    return axiosCommon.post(url, request);
  }

  static updateSpecies(request: SpeciesRequest, speciesId: string): ApiPromise<SpeciesResponse> {
    const url = `${this.baseUrl}/species/${speciesId}`;
    return axiosCommon.put(url, request);
  }
}